var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 540,
    height: 540,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC220",
    d: "M368.4 246c11.3-2.3 111-48 119.8-53a42.4 42.4 0 1 0-42.5-73.5c-8.8 5.1-98.2 68.5-105.9 77.1a30 30 0 0 0-3.8 35.1 30.1 30.1 0 0 0 32.4 14.3ZM488.2 347c-8.9-5-108.5-50.7-119.8-53-13-2.7-25.9 3-32.4 14.3a30 30 0 0 0 3.8 35c7.7 8.7 97 72.1 106 77.2a42.5 42.5 0 0 0 42.4-73.5ZM269.7 346.5c-13 0-24.4 8.4-28.5 20.9-3.7 10.9-14 120-14 130.2a42.4 42.4 0 0 0 85 0c0-10.3-10.3-119.3-14-130.2a30.1 30.1 0 0 0-28.5-20.9ZM171 294c-11.2 2.3-110.9 48-119.8 53a42.4 42.4 0 1 0 42.5 73.5c8.9-5.1 98.3-68.5 106-77.1a30 30 0 0 0 3.7-35.1 30.1 30.1 0 0 0-32.3-14.3ZM93.7 119.5A42.5 42.5 0 0 0 51.2 193c9 5 108.6 50.7 119.9 53 12.9 2.7 25.8-3 32.3-14.3a30 30 0 0 0-3.8-35c-7.6-8.7-97-72.1-105.9-77.2ZM269.7 0c-23.4 0-42.4 19-42.4 42.4 0 10.3 10.2 119.3 13.9 130.2a30.1 30.1 0 0 0 28.5 20.9c13 0 24.4-8.4 28.6-20.9 3.6-10.9 13.9-120 13.9-130.2 0-23.4-19-42.4-42.5-42.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkIcon);
export default __webpack_public_path__ + "static/media/spark-icon.60b2e74d7a53cb0caa6c9972ac9020c2.svg";
export { ForwardRef as ReactComponent };